(function () {
  function buildList(countries, currentCode) {
    const ul = document.createElement('ul');
    ul.setAttribute('role', 'list');
    ul.className = 'list-unstyled countries';
    countries.forEach((c) => {
      const li = document.createElement('li');
      li.className = 'disclosure__item';
      li.tabIndex = -1;
      const a = document.createElement('a');
      a.className = 'link link--text disclosure__link caption-large focus-inset';
      a.href = '#';
      a.dataset.value = c.code;
      if (c.code === currentCode) a.setAttribute('aria-current', 'true');
      a.innerHTML = '<span class="country">' + c.name + '</span>' +
        '<span class="localization-form__currency motion-reduce">' + c.currency + ' ' + (c.symbol || '') + '</span>';
      li.appendChild(a);
      ul.appendChild(li);
    });
    return ul;
  }

  function handleCountrySelect(disclosureEl, code) {
    const form = disclosureEl.closest('form');
    if (!form) return;
    const input = form.querySelector('input[name="country_code"]');
    if (input) input.value = code;
    form.submit();
  }

  function initSelector(disclosureEl) {
    const button = disclosureEl.querySelector('.localization-selector');
    const placeholder = disclosureEl.querySelector('[data-lazy-countries]');
    const jsonScript = disclosureEl.querySelector('script[data-country-json]');
    if (!button || !placeholder || !jsonScript) return;

    button.addEventListener('click', function () {
      if (placeholder.dataset.loaded) return;
      placeholder.dataset.loaded = 'true';

      let countries = [];
      try {
        countries = JSON.parse(jsonScript.textContent);
      } catch (err) {
        console.error('Country list parse failed', err);
      }

      const currentCode = disclosureEl.dataset.currentCountry;
      const ul = buildList(countries, currentCode);
      placeholder.replaceWith(ul);

      ul.addEventListener('click', function (e) {
        const link = e.target.closest('a[data-value]');
        if (!link) return;
        e.preventDefault();
        handleCountrySelect(disclosureEl, link.dataset.value);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.disclosure').forEach((el) => {
      if (el.querySelector('[data-lazy-countries]')) initSelector(el);
    });
  });
})();